import styled, { css } from 'styled-components'

export const CommonPriceElementWrapperUi = styled.div`
  font-family: inherit;
  display: flex;
  justify-content: center;
`

export const CommonPriceElementContainerUi = styled.div`
  position: relative;
  max-width: 1280px;
  width: 100%;

  display: flex;
  flex-direction: column;

  background-color: transparent;

  @media only screen and (max-width: 1000px) {
    padding: 50px 20px;
  }
`

export const CommonPriceElementPlansWrapperUi = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    margin-bottom: 30px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      flex-direction: column;
      margin-bottom: 30px;
    `}
`

export const CommonPriceElementTableContainerUi = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;

  background-color: white;
`

export const CommonPriceElementTitleUi = styled.h2`
  display: inline-block;
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
  font-weight: 700;
  font-size: 40px;
  line-height: 48px;
  color: #181c39;
`

interface CommonPriceElementUnknownUiStylesInterface {
  width?: string
}

export const CommonPriceElementUnknownUi = styled.span<CommonPriceElementUnknownUiStylesInterface>`
  width: ${p => p.width ?? '100%'};
  max-width: 100%;
  height: 20px;
  background-color: #f5f5f5;
  border-radius: 5px;
  display: inline-block;
`

export const CommonPriceElementSubtitle = styled.h2`
  font-size: 60px;
  margin: 100px 0px 60px;
  color: rgb(24, 28, 57);
`

interface CommonPriceElementPlanContainerProps {
  planCount: number
}

export const CommonPriceElementPlanContainerUi = styled.div<CommonPriceElementPlanContainerProps>`
  display: grid;
  grid-template-columns: ${({ planCount }) =>
    `1.2fr repeat(${planCount}, 1fr)`};
  padding: 28px 24px;
`

export const PCommonPriceElementPlanItemUi = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #181c39;
  text-align: center;

  ${p => p.theme.phone} {
    display: none;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    display: none;
  `}
`
